import { createValidator } from "../../scripts/components/form/validation/validator";
import { scrollToIfNeeded } from "@/scripts/common/scroll-to";

let view = 'personal';

const setupDynamicForms = (form) => {
  const personalView = form.querySelector('.personal-view');
  const contactView = form.querySelector('.contact-view');
  const validator = form.dataset.formValidate !== undefined && createValidator(form);

  if (view === 'personal') {
    personalView.classList.remove('hidden');
    contactView.classList.add('hidden');
  }

  if (view === 'contact') {
    personalView.classList.add('hidden');
    contactView.classList.remove('hidden');
  }

  const contactViewTrigger = form.querySelector('.contact-view-trigger');
  if (contactViewTrigger) {
    contactViewTrigger.addEventListener('click', () => {
      if (validator) {
        const result = validator.validateForm();
        const firstError = form.querySelector(".has-error");

        if (!result.isValid) {
          if (firstError && !document.documentElement.classList.contains("has-modal-active")) {
            scrollToIfNeeded(firstError, 32);
          }

          return;
        }
      }

      view = 'contact';
      personalView.classList.add('hidden');
      contactView.classList.remove('hidden');
    });
  }

  const personalViewTrigger = form.querySelector('.personal-view-trigger');
  if (personalViewTrigger) {
    personalViewTrigger.addEventListener('click', () => {
      view = 'personal';
      personalView.classList.remove('hidden');
      contactView.classList.add('hidden');
    });
  }
};

document.addEventListener("DOMContentLoaded", () => {
  const dynamicMultiStepForms = document.querySelectorAll(".dynamic-multi-step-form");

  if (!dynamicMultiStepForms) {
    return;
  }

  dynamicMultiStepForms.forEach((form) => {
    setupDynamicForms(form);
  });
});
